'use client';

import { TestimonialForm } from '@/components/admin/testimonials/TestimonialForm';

export default function AdminTestimonialNewPage() {
  return <TestimonialForm />;
}
